export default __webpack_public_path__ + "static/media/bell-icon.495e048d.svg";